import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'transfix-ui/components/Card'
import { INoteableTypes } from 'types/graphqlTypes'
import Notes from 'apps/marketplace/components/Notes'
import ShipmentIssuesList from './ShipmentIssuesList'

export class NotesCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}

    const { getNoteTags, shipmentId } = this.props
    getNoteTags(shipmentId)
  }

  render() {
    const { mini, notesCount, shipmentId, title, transparent } = this.props

    return (
      <Card collapsible title={title} transparent={transparent} mini={mini}>
        <div className='notes'>
          <section>
            <div>
              <ShipmentIssuesList shipmentId={shipmentId} />
            </div>
            <div>
              <Notes
                noteableId={shipmentId}
                noteableType={INoteableTypes.Shipment}
                notesCount={notesCount}
                inputLocation='top'
                disableFilters
                disableHeader
                disableBorder
              />
            </div>
          </section>
        </div>
      </Card>
    )
  }
}

NotesCard.propTypes = {
  shipmentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  mini: PropTypes.bool,
  transparent: PropTypes.bool,
  title: PropTypes.string,
  notesCount: PropTypes.number,
}

NotesCard.defaultProps = {
  mini: true,
  transparent: true,
  title: 'Notes',
  notesCount: 2,
}
